import React from "react"
import Button from "../../../../../_components/Button"
import Modal from "../../../../../_components/Modal"
import Text from "../../../../../_components/Text"
import { deleteICMSTemplate } from "../../../../../api/products"
import { toast } from "react-toastify"

export default (props) => {
  const [show, setShow] = React.useState(false)
  const [loading, setLoading] = React.useState(false)

  const closeModal = () => {
    if (loading) return
    setShow(false)
  }

  const handleDelete = async () => {
    setLoading(true)
    try {
      await deleteICMSTemplate(props.id)

      toast.success(<Text color="white">ICMS desativado com sucesso.</Text>, {
        autoClose: 3000,
        toastId: "success-delete-icms",
      })

      setTimeout(() => {
        window.location.reload()
      }, 3000)

    } catch (error) {
      console.error("Error deleting ICMS template:", error)

    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      <Button onClick={() => setShow(true)} as="text">
        <i className="fas fa-trash text-danger"></i>
      </Button>
      <Modal show={show} onHide={closeModal} title="Confirmação de desativação">
        <Text align="center">
          O modelo de ICMS "<strong>{props.title}</strong>" será desativado. Você deseja desativá-lo?
        </Text>
        <p className="text-info pt-5">
            * Caso este modelo já estiver associado a produtos, o mesmo permanecerá associado, porém, o template desativado não poderá ser utilizado em novos produtos ou associá-lo a produtos já existentes pois será removido da opção de selecionar ICMS.
        </p>
        <hr className="my-3" />
        <div className="d-flex justify-content-between gap-2">
          <Button as="text" variant="danger" onClick={closeModal} disabled={loading}>
            Não
          </Button>
          <Button variant="danger" onClick={handleDelete} disabled={loading}>
            Sim
          </Button>
        </div>
      </Modal>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/Taxes/ICMS/DeleteICMS/index.jsx